import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { SeccionEstimacionesSiniestroComponent } from '../seccion-estimaciones-siniestro/seccion-estimaciones-siniestro.component';
import { SelectionModel } from '@angular/cdk/collections';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { combineLatest, Subscription } from 'rxjs';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-seccion-verifica-reglas-siniestro',
    templateUrl: './seccion-verifica-reglas-siniestro.component.html',
    styleUrls: ['./seccion-verifica-reglas-siniestro.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatCheckbox, FormsModule, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, MatPaginator, MatDialogActions, MatButton]
})
export class SeccionVerificaReglasSiniestroComponent {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  public verififcaReglasSiniestro = new MatTableDataSource([]);

  public tamanoResultadosReglas: number = 0;
  public selectCoberturasDatosReglas = null;
  public selectedCoberturaRowIndexReglas: number = null;
  public selection = new SelectionModel<any>(true, []); // true = selección múltiple

  public displayColumns = ['Clave', 'Regla', 'Seleccion'];
  public detalleSiniestro = null;
  public siniestro: string;
  public listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SeccionEstimacionesSiniestroComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.obtenerReduxState();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestro = siniestro;
      this.detalleSiniestro = detalleSiniestro
      this.consultarReglasAjuste(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  consultarReglasAjuste(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaReglasAjuste(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Resultado.Reglas.length) {
          this.verififcaReglasSiniestro = new MatTableDataSource(value.Resultado.Reglas);
          this.verififcaReglasSiniestro.paginator = this.paginator;
        } else {
          this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ninguna regla registrada para la causa ${this.detalleSiniestro.siniestroDetalle?.Siniestro?.[0]?.desc_causa}`, 'info', false, true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  toggleRow(row: any) {
    this.selection.toggle(row);
  }

  guardarSeleccion() {
    const seleccionados = this.selection.selected;
    console.log('Seleccionados:', seleccionados);
    const todasReglas = this.procesosComunesService.generarCadenaReglas(this.verififcaReglasSiniestro.data);
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(this.siniestro);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      cadenaReglas: todasReglas
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.actualizaReglasAjuste(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        if (value.Exito == true) {
          this.consultarReglasAjuste(this.siniestro);
          this.procesosComunesService.alertaGeneralComplemento('Guardado', `Las reglas se actualizaron correctamente`, 'success', false, true);
        } else {
          this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ninguna regla registrada para la causa ${this.detalleSiniestro.siniestroDetalle?.Siniestro?.[0]?.desc_causa}`, 'info', false, true);
        }
        this.closeDialog('Aceptar');
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos guardar o actualizar las reglas de ajuste.' }));
      },
    })
  }
}
